import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup} from "@angular/forms";
import {IUser} from "../../../../../../@core/interfaces/user/user.interface";
import {UserService} from "../../../../../../@shared/services/user.service";

@Component({
  selector: 'app-payout-lock-settings',
  templateUrl: './payout-lock-settings.component.html',
  styleUrls: ['./payout-lock-settings.component.scss']
})
export class PayoutLockSettingsComponent {

  public payoutLockForm: FormGroup = this.fb.group({
    isLock: true,
    endAt: '',
    availablePayoutSum: 0,
    unlockPaymentSum: 0,
    lockReason: ''
  });

  constructor(
    public dialogRef: MatDialogRef<PayoutLockSettingsComponent>,
    private readonly fb: FormBuilder,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public user: IUser) {

    if (user.security.userPayoutLock) {
      this.payoutLockForm.patchValue(user.security.userPayoutLock);
    }
  }

  public onSubmit(): void {
    this.userService.createOrUpdateUserPayoutLock(this.payoutLockForm.value).subscribe(() => this.dialogRef.close(this.payoutLockForm.value));
  }

  close() {
    this.dialogRef.close();
  }


}
